import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { formatPrice } from 'utils/formatString';

import { EmptyButton, HTML } from 'components';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const BuyPackagesRow = (props) => {
  const {
    title,
    packages,
    onChange,
    titleClass,
  } = props;
  const [activePackage, setActivePackage] = useState(null);

  const onPackageClick = (soc) => {
    const isActive = activePackage === soc;
    setActivePackage(isActive ? null : soc);
    onChange(isActive ? null : packages.find((item) => item.soc === soc));
  };

  return (
    <div>
      <HTML as="div" className={cx('title', titleClass)}>{title}</HTML>
      <div className={cx('row')}>
        {packages.map(({
          value,
          unit,
          priceValue,
          priceUnit,
          soc,
        }, i) => (
          <EmptyButton
            className={cx('packageBtn', {
              roundLeft: i === 0,
              roundRight: i === packages.length - 1,
              active: activePackage === soc,
            })}
            key={soc}
            onClick={() => onPackageClick(soc)}
          >
            <HTML as="div" className={cx('packageValue')}>{`+${value} ${unit}`}</HTML>
            <HTML as="div" className={cx('packagePrice')}>
              {formatPrice(priceValue)}
              {' '}
              {priceUnit}
            </HTML>
          </EmptyButton>
        ))}
      </div>
    </div>
  );
};

BuyPackagesRow.propTypes = {
  title: PropTypes.string,
  packages: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    unit: PropTypes.string,
    priceValue: PropTypes.string,
    soc: PropTypes.string,
    priceUnit: PropTypes.string,
  })),
  titleClass: PropTypes.string,
  onChange: PropTypes.func,
};

export default BuyPackagesRow;
